import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function FAQ() {
  const [openItem, setOpenItem] = useState(null);

  const faqItems = [
    {
      question: "Cilat shërbime ofroni?",
      answer: "Ofrojmë një gamë të gjerë shërbimesh duke përfshirë kontabilitet të tatimeve, auditim të brendshëm, konsulencë financiare, menaxhim financiar dhe analizë biznesi. Të gjitha shërbimet tona janë të përshtatura për nevojat specifike të biznesit tuaj."
    },
    {
      question: "Sa kushton një konsulencë fillestare?",
      answer: "Konsulenca fillestare është falas dhe ju lejon të diskutoni nevojat tuaja me ekipin tonë të ekspertëve. Pas kësaj, do të ju ofrojmë një kuotim të personalizuar bazuar në shërbimet që ju nevojiten."
    },
    {
      question: "Sa kohë duhet për të përfunduar një auditim?",
      answer: "Kohëzgjatja e një auditimi varet nga madhësia dhe kompleksiteti i biznesit. Zakonisht, një auditim i plotë mund të zgjasë nga 2-4 javë. Do të ju japim një plan të detajuar kohor në fillim të projektit."
    },
    {
      question: "A ofroni shërbime online?",
      answer: "Po, shumë nga shërbimet tona mund të ofrohen online përmes platformave të sigurta. Kjo ju lejon të punoni me ne nga kudo që jeni, duke ruajtur të njëjtën cilësi dhe siguri."
    },
    {
      question: "Cilat janë kualifikimet e ekipit tuaj?",
      answer: "Ekipi ynë përbëhet nga profesionistë të certifikuar me më shumë se 45 vjet përvojë të kombinuar. Të gjithë anëtarët kanë certifikimet e nevojshme dhe ndjekin trajnime të vazhdueshme për të qenë të përditësuar me zhvillimet më të fundit."
    },
    {
      question: "A mbrojmë konfidencialitetin e të dhënave?",
      answer: "Absolutisht! Konfidencialiteti është një nga vlerat kryesore të kompanisë sonë. Të gjitha informacionet e klientëve tanë mbrohen me standardet më të larta të sigurisë dhe konfidencialitetit."
    },
    {
      question: "Si mund të filloj të punoj me ju?",
      answer: "Për të filluar, thjesht na kontaktoni përmes telefonit, emailit ose formës së kontaktit në faqen tonë. Do të organizojmë një takim fillestar për të diskutuar nevojat tuaja dhe për të zhvilluar një plan të personalizuar."
    },
    {
      question: "A ofroni shërbime për biznese të vogla?",
      answer: "Po, ofrojmë shërbime për biznese të të gjitha madhësive, nga biznese të vogla deri te korporata të mëdha. Çdo biznes ka nevoja unike dhe ne i përshtatim shërbimet tona në përputhje me to."
    }
  ];

  const toggleItem = (index) => {
    setOpenItem(openItem === index ? null : index);
  };

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>Pyetje të Shpeshta</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="faq-intro">
            <h2>Kërkoni Informacion?</h2>
            <p>Këtu gjeni përgjigjet për pyetjet më të zakonshme që na bëjnë klientët tanë. Nëse nuk gjeni përgjigjen që kërkoni, mos hezitoni të na kontaktoni.</p>
          </div>
          
          <div className="faq-list">
            {faqItems.map((item, index) => (
              <div key={index} className={`faq-item ${openItem === index ? 'open' : ''}`}>
                <div 
                  className="faq-question"
                  onClick={() => toggleItem(index)}
                >
                  <h3>{item.question}</h3>
                  <span className="faq-toggle">
                    {openItem === index ? '−' : '+'}
                  </span>
                </div>
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="faq-contact">
            <h2>Keni Pyetje të Tjera?</h2>
            <p>Nëse nuk gjeni përgjigjen që kërkoni, ekipi ynë është këtu për t'ju ndihmuar.</p>
            <div className="contact-options">
              <div className="contact-option">
                <h3>Na Telefononi</h3>
                <p>+383 44 220 640</p>
              </div>
              <div className="contact-option">
                <h3>Na Shkruani</h3>
                <p>info@shalaaccounting.com</p>
              </div>
              <div className="contact-option">
                <h3>Na Vizitoni</h3>
                <p>Prishtinë, Kosovë</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FAQ; 